import { Ability } from '@casl/ability';
import ABILITIES from './abilityRules';

function subjectName(item) {
  return !item || typeof item === 'string' ? item : item.__type;
}

function defineAbilities() {
  return new Ability(this.getRoleAbilities('default'), { subjectName });
}

function getRoleAbilities(role) {
  return ABILITIES.get(role);
}

export default { defineAbilities, getRoleAbilities };
